import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'

import { formatURI } from '../../../api/common/utils'

import FacebookIcon from '../icon/facebook.svg'

export const Share = (url) => {
  const shareURL = 'https://www.facebook.com'
  const sharePath = '/sharer/sharer.php'
  const shareQuery = {
    u: url
  }

  if (typeof window !== 'undefined') {
    const appIdElement = document.querySelector('[property="fb:app_id"]')
    const appId = appIdElement ? appIdElement.content : null
    appId && (shareQuery.app_id = appId)

    shareQuery.u = window.location.origin + shareQuery.u
  }

  const newWindow = window.open(
    formatURI(shareURL, sharePath, shareQuery), '_blank'
  )
  newWindow.focus()
}

const ShareOnFacebook = ({ url, outline = false, ...attrs }) => {
  const handleShare = () => {
    Share(url)
  }

  attrs.className = classNames(
    attrs.className,
    [
      'flex',
      'fex-row',
      'items-center',
      'cursor-pointer'
    ]
  )

  return <div
    {...attrs}
    onClick={handleShare}>
    <div
      className={
        classNames([
          outline ? '' : 'mr-4',
          'cursor-pointer',
          outline ? 'text-black' : 'text-white'
        ])
      }
      style={{
        width: '2rem',
        height: '2rem',
        padding: '0.25rem',
        backgroundColor: outline ? '' : '#3C5997'
      }}>
      <FacebookIcon
        width={24}
        height={24} />
    </div>
    {
      outline
        ? null
        : <Typography>
          Facebook
        </Typography>
    }
  </div>
}

ShareOnFacebook.propTypes = {
  url: PropTypes.string,
  outline: PropTypes.bool
}

export default ShareOnFacebook
